import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { APP_NAME } from "./config/brand";
import "./index.css";

// Bootstrap only — excluded from coverage (vite.config.ts documents why).
document.title = APP_NAME;
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
